export default {
  header: 'Order & Sales Management',
  title: 'OSM',
  agentInfo: {
    header: 'FC Information',
    agent: 'FC',
    agentSplitRate: 'FC Split Rate',
    isActive: 'Is Active',
    isServiceAgent: 'Is Service FC',
    effectiveDate: 'Effective Date',
    expiryDate: 'Expiry Date',
    totalSplitRate: 'Total :',
    deleteAgentConfirm: '<h5>Are you sure to <span class="text-danger">Delete</span> FC with contents below?</h5> <p>FC English Name: {agentEnglishName}</p><p>FC Chinese Name: {agentChineseName}</p>'
  },
  contents: {
    general: {
      agentRemarks: 'FC Remarks',
      renewal: "Renewal",
      page: 'Page',
      total: 'Total',
      items: 'items',
      life: 'Life',
      gi: 'GI',
      detail: 'Detail',
      delete: 'Delete',
      deleteSuccess: 'Delete Policy Success!',
      deletePolicyConfirm: '<h5>Are you sure to <span class="text-danger">Delete</span> policy with contents below?</h5> <p>Policy Number: {policyNumber}</p><p>Policy Reference : {policyRef}</p>',
      attachment: 'Attachment',
      actions: 'Actions',
      create: 'Create New',
      policyStatus: 'Policy Status',
      workFlowStep: 'Workflow Step',
      updateTime: 'Last Updated Time',
      serviceRequest: { title: 'Service Request' },
      outstandingRequirement: { title: 'Outstanding Requirement' },
      rejectedPolicy: 'Rejected Policy',
      completedPolicy: 'Completed Policy',
      rejectedPolicyModal: '<p>You have rejected this policy successfully.</p><p>The page will be return to {type} Policy List.</p>',
      completedPolicyModal: '<p>You have completed this policy successfully.</p><p>The page will be return to {type} Policy List.</p>',
      addRiderConfirm: 'Are you sure to Add Rider {name} to this Policy ?',
      removeRiderConfirm: 'Are you sure to Remove Rider {name} from this Policy ?',
      changeBusiness: {
        title: 'Change Business',
        lapseDate: 'Policy Lapse Date',
        surrenderDate: 'Policy Surrender Date',
        reinstateDate: 'Policy Reinstate Date',
        transferOut: 'Transfer Out',
        coolingOff: 'Cooling Off',
        transferIn: 'Transfer In',
        changePremiumType: 'Change Premium Type',
        confirmActionContent: '<p><b>Policy Number:</b> {policyNumber}</p><p><b>Policy Reference:</b> {policyReference}</p><p><b>Policy Owner:</b> {policyOwner}</p>',
        confirmActionWarning: '<p>Are you sure to {action} the policy above?</p>',
        transferInConfirm: 'Are you sure to Transfer In the policy?',
        lapse: 'Lapse',
        surrender: 'Surrender',
        reinstate: 'Reinstate',
      }
    },
    lifePolicy: {
      header: 'Life Policy',
      new: ' Create Life Policy',
      generalInfo: 'General Information',
      general: 'General',
      internalUse: 'Internal Use',
      currentWorkflow: 'Workflow',
      policyStatus: 'Status',
      policyType: 'Type',
      payment: 'Payment',
      lifePolicy: 'Life Policy',
      lifePolicyList: 'Life Policy List',
      lifeDetail: 'Detail',
      lifeOr: 'Outstanding Requirement',
      lifeTransferIn: 'Transfer In',
      workflowCreate: 'Create',
      workflowConfirm: 'Confirm',
      workflowSentOut: 'Sent Out',
      workflowUnderwriting: 'Underwriting',
      workflowInforce: 'Inforce',
      workflowReject: 'Reject',
      workflowCompanyReceive: 'Company Receive',
      workflowAgentReceive: 'FC Receive',
      workflowCustomerReceive: 'Customer Receive',
      generalInformation: {
        policyAgent: 'FC',
        approveAgent: 'Approve FC',
        policyStatus: 'Policy Status',
        riders: {
          title: 'Riders',
          description: 'Description',
          riderPremium: 'Rider Premium',
          riderStatus: 'Rider Status'
        },

        approveAgent: 'Approve FC',
        paymentTerm: 'Payment Term',
        paymentMode: 'Payment Mode',
        attachment: 'Attachment',
        workFlowStep: 'Workflow Step',
        productName: 'Product Name',
        policyNumber: 'Policy Number',
        policyReference: 'Policy Reference',
        policyTerm: 'Policy Term',
        policyCurrency: 'Policy Currency',
        premiumType: 'Premium Type',
        initialPremium: 'Initial Premium',
        modalPremium: 'Modal Premium',
        initialPremiumErrorMsg:'Initial Premium should be multiple of Modal Premium',
        totalPremiums: 'Total Premiums',
        applicationDate: 'Application Date',
        applicationReceivedDate: 'Application Received Date',
        conditionalAssignmentFlag: 'Conditional Assignment Flag',
        originalAgent: 'Original FC',
        currentAgent: 'Current FC',
        originalReferrer: 'Original Referrer',
        policyOwner: 'Policy Owner',
        insurer: 'Life Insured',
        beneficiary: 'Beneficiary',
        thirdParty: 'Third Party',
        remarks: 'Remarks',
        docs: 'Upload Documents',
        paymentDate: 'Payment Date',
        paymentMethod: 'Renewal Method',
        paymentAmount: 'Payment Amount',
        sentOutDate: 'Sent Out Date',
        sentOutMedium: 'Sent Out Medium',
        sentOutReference: 'Sent Out Reference',
        companyBank: 'Company Bank',
        paymentReference: 'Payment Reference',
        commencementDate: 'Commencement Date',
        issueDate: 'Issue Date',
        welcomeLetterSentOutDate: 'Welcome Letter Sent Out Date',
        companyReceiveDate: 'Company Receive Date',
        agentReceiveDate: 'FC Receive Date',
        customerReceiveDate: 'Customer Receive Date',
        //
        levy: 'Levy'
      }
    },
    giPolicy: {
      header: 'GI Policy',
      new: 'Create GI Policy',
      generalInfo: 'General Information',
      policyInfo: 'Policy Information',
      general: 'General',
      fee: 'Fee',
      internalUse: 'Internal',
      commission: 'Commission',
      payment: 'Payment',
      policyAgent: 'FC',
      currentWorkflow: 'Workflow',
      policyStatus: 'Status',
      policyType: 'Type',
      giPolicy: 'GI Policy',
      giPolicyList: 'GI Policy List',
      giPolicyDetail: 'Detail',
      giOr: 'Outstanding Requirement',
      workflowCreate: 'Create',
      workflowConfirm: 'Confirm',
      workflowSentOut: 'Sent Out',
      workflowUnderwriting: 'Underwriting',
      workflowInforce: 'Inforce',
      workflowReject: 'Reject',
      workflowCompanyReceive: 'Company Receive',
      workflowAgentReceive: 'FC Receive',
      workflowCustomerReceive: 'Customer Receive',

      generalInformation: {
        serviceAgent: 'Service FC',
        policyAgent: 'FC',
        approveAgent: 'Approve FC',
        attachment: 'Attachment',
        actions: 'Actions',
        policyStatus: 'Policy Status',
        workFlowStep: 'Workflow Step',
        updateTime: 'Last Updated Time',
        policyOwnerName: 'Policy Owner Name',
        currentAgentName: 'Current FC Name',
        productName: 'Product Name',
        policyNumber: 'Policy Number',
        policyReference: 'Policy Reference',
        applicationDate: 'Application Date',
        applicationReceiveDate: 'Application Receive Date',
        policyCurrency: 'Policy Currency',
        policyType: 'Policy Type',
        modalPremium: 'Modal Premium',
        premiumPaid: 'Premium Paid',
        premiumType: 'Premium Type',
        premiumTypeOptions: {
          annual: 'Annual',
          halfYear: 'Half year',
          quater: 'Quater',
          month: 'Month'
        },
        actuallyPaid: 'Actually Paid',
        paymentMethod: 'Renewal Method',
        paymentAmount: 'Payment Amount',
        companyBank: 'Company Bank',
        paymentReference: 'Payment Reference',
        paymentMethodOptions: {
          cheque: "Cheque",
          bankTransfer: "Bank Transfer",
          bankIn: "Bank In"
        },
        docs: 'Upload Documents',
        paymentDate: 'Payment Date',
        originalAgent: 'Original FC',
        currentAgent: 'Current FC',
        ownerCustomer: 'Owner Customer',
        policyFee: 'Policy Fee',
        insuredCustomer: 'Insured Customer',
        agentCommissionRate: 'FC Commission Rate (%)',
        agentCommissionPaid: 'FC Commission Paid',
        newBusinessOrRenewal: 'New Business Or Renewal',
        newBusinessOrRenewalOptions: {
          newBusiness: 'New Business',
          renewal: 'Renewal',
          pleaseSelect: '-- Please select policy type --'
        },
        levyOrMIB: 'Levy or MIB',
        specialLevy: 'Special Levy',
        remarks: 'Remarks',
        premiumPaid: 'Premium Paid',
        insurerRebate: 'Insurer Rebate',
        chequeToInsurer: 'Amount of Cheque to Insurer',
        chequeToInsurerNumber: 'Cheque to Insurer Cheque Number',
        chequeIssueDate: 'Cheque Issue Date',
        sentOutDate: 'Sent Out Date',
        sentOutMedium: 'Sent Out Medium',
        sentOutReference: 'Sent Out Reference',
        sentOutMediumOptions: {
          email: 'Email',
          courier: 'Courier',
        },
        courierNo: 'Courier No.',
        effectiveDate: 'Effective Date',
        expiryDate: 'Expiry Date',
        issueDate: 'Issue Date',
        companyReceiveDate: 'Company Receive Date',
        agentReceiveDate: 'FC Receive Date',
        customerReceiveDate: 'Customer Receive Date'
      },
      productInformation: {
        //Travel
        coverageType: 'Coverage Type',
        packageType: 'Package Type',
        travelType: 'Travel Type',
        days: 'Days',
        destination: 'Destination',

        //contrator all risk
        contractSum: 'Contract Sum',
        limitOfIndemnity: 'Limit of Indemnity',
        nameOfInsured: 'Name of Insured',
        nameOfPrincipal: 'Name of Principal',
        natureOfBusiness: 'Nature of Business',
        periodOfInsurance: 'Period of Insurance',
        riskLocation: 'Risk Location',
        typeOfCoverage: 'Type of Coverage',

        //Domestic helper
        coverage: 'Coverage',
        insurancePeriod: 'Insurance Period (Month)',
        nameOfEmployee: 'Name of Employee',
        placesEmployed: 'Places Employed',

        //employee comp
        employeeRiskRate: 'Employee Risk Rate',
        estAnnualSalary: 'Estimated Annual Salary',
        occupation: 'Occupation',

        riskRate: 'Risk Rate',
        mortgagee: 'Mortgagee',

        //healthMedical
        optionalBenefits: 'Optional Benefits',
        relationship: 'Relationship',
        typeOfHealth: 'Type of Health',
        typeOfPlan: 'Type of Plan',

        //home protection
        grossArea: 'Gross Area',
        homeContent: 'Home Content',
        propertyAge: 'Property Age',

        //motor
        bodyType: 'Type Body',
        capacity: 'Capacity',
        chassisNumber: 'Chassis Number',
        coverageType: 'Coverage Type',
        engineNumber: 'Engine Number',
        hirePurchaseOwner: 'Hire Purchase Owner',
        makeAndModel: 'Make and Model',
        namedDriver: 'Named Driver',
        ncb: 'Non Claims Bonus',
        seatsExcDriver: 'Seats Excluding Driver',
        sumInsured: 'Sum Insured',
        typeOfVehicle: 'Type of Vehicle',
        vehicleNumber: 'Vehicle Number',

        //office Package
        numberOfEmployee: 'Number of Employee',
        officeContent: 'Office Content',
        officeRiskRate: 'Office Risk Rate',
        title: 'Title',

        //personal accident
        acciDeathNPermDisableAmt: 'Accidental Death and Permernant Disable Amount',
        acciDeathNPermDisablePrem: 'Accidental Death and Permernant Disable Premium',
        acciMediExpPerAcciAmt: 'Accidental Medical Expenses per Accidental Amount',
        acciMediExpPerAcciPrem: 'Accidental Medical Expenses per Accidental Premium',
        classOfOccupation: 'Class of Occupation',
        hosCashAllowPerDayAmt: 'Hospital Cash Allow per Day Amount',
        hosCashAllowPerDayPerm: 'Hospital Cash Allow per Day Permium',
        incomeProtPerYrAmt: 'Income Protection per Year Amount',
        incomeProtPerYrPerm: 'Income Protection per Year Permium',

        //shop package
        stock: 'Stock',
        stockRiskRate: 'Stock Risk Rate',

        //china medical card
        occupation: 'Occupation',
        planCovered: 'Plan Covered',

        //machinery all risk
        insuredPremises: 'Insured Premises',
        itemDescription: 'Item Description',

        //property all risk
        riskLocation: 'Risk Location',

        //marine cargo
        nameOfAssured: 'Name of Assured',
        vesselName: 'Vessel Name',
        voyage: 'Voyage',
        content: 'Content',

        //group personal accident
        scopeOfCover: 'Scope of Cover',
        aggrateLimit: 'Aggrate Limit',
        totalHeadcount: 'Total Headcount',

        //product liability
        businessNature: 'Business Nature',
        productDescription: 'Product Description',
        turnover: 'Turnover'
      }
    }
  },

  serviceRequest: {
    original: 'Original Information',
    new: 'New Information',
    comparison: 'Comparaison',
    serviceType: 'Service Type',
    comment: 'Comment',
    receiveTime: 'Receive Time',
    completeTime: 'Complete Time',
    approval: 'Approval',
    header: 'Service Request',
    srList: 'List',
    approve: 'Approve',
    reject: 'Reject',
    fileUpload: 'File Attachment',
    creator: 'Creator',
    select: {
      header: 'Select Service Request',
      type: 'Request Type'
    },
    'workflow-1': 'Create Service Request',
    'workflow-2': 'Update Service Request Status',
    customer: 'Customer',
    agent: 'FC',
    searcgAgent: 'Search FC',
    searchCustomer: 'Search Customer',
    policyType: 'Policy Type',
    status: 'SR Status',
    policyInformation: 'Policy Information',
    policy: {
      policyNumber: 'Policy Number',
      policyReference: 'Reference Number',
      policyStatus: 'Status',
      currency: 'Currency',
      lastUpdateTime: 'Last Update',
      modalPremium: 'Modal Premium',
      paymentMethod: 'Payment Method',
      premiumType: 'Premium Type',
      totalWithdrawals: 'Total Withdrawal',
      currentLoanAmount: 'Loan Amount',
    },

    select: {
      header: 'Select Service Request',
      agent: 'FC',
      policyDetail: 'Policy Information',
      policyStatus: 'Policy Status',
      policyValue: 'Policy Value',
    },

    confirm: {
      header: 'Confirmation',
      body: {
        approve: 'Are you sure to APPROVE this service request',
        reject: 'Are you sure to REJECT this service request'
      }
    },

    type: {

      CPM: {
        header: 'Change Renewal Method',
        paymentMethod: 'Renewal Method',
        paymentReference: 'Payment Reference',
        companyBank: 'Company Bank',
        paymentDate: 'Payment Date',
        paymentStartDate: 'Payment Start Date',
        paymentEndDate: 'Payment End Date',
      },
      CAS: {
        header: 'Assignment',
        initialAgent: 'Initial FC',
        currentAgent: 'Current FC',
      },
      CBF: {
        header: 'Change Beneficiary',
        beneficiary: 'Beneficiary'
      },
      CPO: {
        header: 'Change Premium Type',
        premiumType: 'Premium Type'
      },
      CGA: {
        header: 'Change Premium Amount',
        modalPremium: 'Modal Premium'
      },
      CPA: {
        header: 'Change Premium Amount',
        premiumAmount: 'Modal Premium'
      },
      PLO: {
        header: 'Policy Loan',
        currentLoanAmount: 'Current Loan Amount'
      },
      PSE: {
        header: 'Policy Settle',
        currentLoanAmount: 'Current Loan Amount'
      },
      PAU: {
        header: 'Paid-Up',
        policyPaidUpDate: 'Paid-Up Date'
      },
      REI: {
        header: 'Reinstatement'
      },
      SUR: {
        header: 'Surrender',
        policyEndDate: 'Policy End Date'
      },
      SUS: {
        header: 'Suspension'
      },
      WID: {
        header: 'Withdrawal',
        totalWithdrawals: 'Total Withdrawal'
      },
      CRI: {
        header: 'Change Rider',
        removeRider: 'Remove',
        recoverRider: 'Recover',
        newRider: 'New Rider',
        riderProduct: 'Product',
        riderPremium: 'Premium'
      },
      CPB: {
        header: 'Change Policy Benefit',
        modalPremium: 'Modal Premium'
      },
      HOL: {
        header: 'Change Policy Holiday'
      },
      TRO: {
        header: 'Transfer Out',
        policyEndDate: 'Policy End Date'
      },
      GAS: {
        header: 'Assignment',
        currentAgent: 'Current FC'
      },
      LAP: {
        header: 'Lapse',
        policyLapseDate: 'Policy Lapse Date'
      },
      GAP: {
        header: 'Lapse',
        policyLapseDate: 'Policy Lapse Date'
      },
      DSA: {
        header: 'Delegated Switching Authority'
      },
      MTA: {
        header: 'MPF Transfer Asset'
      },
      SRD: {
        header: 'Switching / Redirection'
      },
    }
  },
  provider: {
    header: 'Provider',
    providerCode: 'Provider Code',
    edit: {
      header: 'Edit',
    },
    delete: {
      header: 'Delete',
      confirmDelete: '<h5>Are you sure to <span class="text-danger">DELETE</span> provider with contents below?</h5> <p>Provider Code: {providerCode}</p><p>Provider Chinese Name: {providerChineseName}</p><p>Provider English Name: {providerEnglishName}</p>'
    },
    create: {
      header: 'Create Provider',
      providerEnglishName: 'Provider English Name',
      providerChineseName: 'Provider Chinese Name',
      providerDescription: 'Provider Description',
      providerCountry: 'Provider Country',
      mailingAddress: 'Mailing Address',
      relationshipManager: 'Relationship Manager',
      contactNumber: 'Contact Number',
      brokerHotline: 'Broker Hotline',
      splitRate: "Split Rate(%)",
      splitRate2: "Split Rate 2(%)",
    },
    list: {
      header: 'Provider List',
      providerName: 'Provider Name',
      brokerHotline: 'Broker Hotline',
      updateTime: 'Last Update'
    }
  },
  product: {
    header: 'Product',
    create: {
      header: 'Create Product',

    },
    list: {
      header: 'Product List',
      updateTime: 'Last Update',
    },
    delete: {
      header: 'Delete Product',
      confirmDelete: '<h5>Are you sure to <span class="text-danger">DELETE</span> product with contents below?</h5><table><tr><td><b>Product Code:</b></td><td>{productCode}</td></tr><tr><td><b>Product Chinese Name:</b></td> <td>{productChineseName}</td></tr><tr><td><b>Product English Name:</b></td><td>{productEnglishName}</td></tr><table>'
    },
    edit: {
      header: 'Edit Product',
    },
    commission: {
      modify: 'Are you sure to {action} the Commission Set {number}?',
      modifyPending: 'Are you sure to {action} the Pending Commission Set {number}?',
      currentCommissionModal: 'Are you sure to edit Current Commission Set?',
      addCommission: 'Add Commission Set',
      editCommission: 'Edit Commission Set',
    },
    productName: 'Product Name',
    productCode: 'Product Code',
    productCodeByIssuer: 'Product Code By Issuer',
    productEnglishName: 'Product English Name',
    productChineseName: 'Product Chinese Name',
    productType: 'Product Type',
    remarks: 'Remarks',
    status: 'Status',
    effectiveDateFrom: 'Effective From',
    effectiveDateTo: 'Effective To',
    policyFeeHkd: 'Policy Fee (HKD)',
    policyFeeUsd: 'Policy Fee (USD)',
    allowCommissionRateOver100: 'Allow Commission Rate Over 100%',
    commissionEffectiveFrom: 'Commission Effective From',
    commissionEffectiveTo: 'Commission Effective To',
    firstYearCommissionRate: 'First Year Commission Rate',
    year1Override: 'Year 1 Override(%)',
    year2Override: 'Year 2 Override(%)',
    year1AnnualBonus: 'Year 1 Annual Bonus(%)',
    year2AnnualBonus: 'Year 2 Annual Bonus(%)',
    yearComm: 'Year {year} Commission(%)',
    commissionSet: 'Commission Set',
    pendingCommissionSet: 'Pending Commission Set',
    currentCommissionSet: 'Current Commission Set',
    historyCommissionSet: 'Historical Commission Set'
  },
  renewal: {
    header: 'Renewal',
    history: 'Renewal History',
    quickRenew: 'Renewal List',
    list: {
      modalPremium: 'Modal Premium',
      nextPaymentDateFrom: 'Payment Date From',
      nextPaymentDateTo: 'Payment Date To',
      dateFromUpdateTime: 'Update Date From',
      dateToUpdateTime: 'Update Date To',
      policyType: 'Policy Type',
      header: 'Renewal Record List',
      nextPaymentDate: 'Next Payment Date',
      showRecentOnly: 'Show Latest Record Only',
      updateTime: 'Last Update Time'
    },
    dueIn: 'Payment Due In',
    renew: 'Renew',
    renewLife: {
      header: 'Renew Life',
      period: 'Period',
      actualPaymentDate: 'Actual Payment Date',

    },
  },
  claim: {
    header: 'Claim',
    apply: 'Apply Claim',
    policyReference: 'Policy Reference',
    policyType: 'Policy Type',
    status: 'Status',
    agentName: 'FC Name',
    claimType: 'Claim Type',
    expectedClaimAmount: 'Expected Claim Amount',
    updateTime: 'Update Time',
    agentCode: 'FC Code',
    claimRequestDate: 'Claim Request Date',
    claimResponseDate: 'Claim Response Date',
    policy: 'Policy',
    remark: 'Remarks',
    claimResult: 'Claim Result',
    companyReceiveDate: 'Company Receive Date',
    agentReceiveDate: 'FC Receive Date',
    customerReceiveDate: 'Customer Receive Date',
    claimIssueDate: 'Claim Issue Date',
    claimPaymentMethod: 'Claim Payment',
    claimReference: 'Claim Reference',
    claimAmount: 'Claim Amount',
    attachment: 'Attachments',
    detail: {
      header: 'Claim Detail'
    },
    list: {
      header: 'Claim List',
    },
    create: {
      header: 'Create Claim',
      'workflow-1': 'Apply Claim',
      'workflow-2': 'Pending',
      'workflow-3': 'Claim Detail',
      'workflow-4': 'Completed Claim',
      confirmModal: '<h5>Are you sure to <b class="text-danger">{action}</b> the claim?</h5>',
      claimResultModal: '<h5>Are you sure to <b class="text-danger">{action}</b> the claim result?</h5>',
      saveResult: 'Save',
      createResult: 'Create',
    }
  }

}



// WEBPACK FOOTER //
// ./src/Osm/langs/en_us/index.js